import React from 'react';
import RealScoreContainer from 'components/admin/manage/edd/realscore/RealScoreContainer';

export const RealScorePage = () => {
  return <RealScoreContainer />;
};
